import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import firebase from 'firebase/app';
import { useSelector } from 'react-redux';

const ResumenEntrega = ({ eventoIndex }) => {
    const [resumen, setResumen] = useState({ entregados: 0, porEntregar: 0 });

    const eventParticipants = useSelector(
        (state) => state.registry.eventParticipants
    );

    useEffect(() => {
        const data = eventParticipants;
        let entregados = 0;
        let porEntregar = 0;

        for (const key in data) {
            const p = data[key];
            if (p.statusPago?.status === 'ok' && !p.borrado) {
                if (p.entregaKit) entregados++;
                else porEntregar++;
            }
        }

        setResumen({ entregados, porEntregar });

    }, [eventoIndex, eventParticipants]);

    return (
        <Grid container spacing={2} style={{ marginTop: 24 }}>
            <Grid item xs={6}>
                <Paper style={{ padding: 16, textAlign: 'center', backgroundColor: '#ffebee', margin: 10 }}>
                    <Typography variant="h6">Kits Entregados</Typography>
                    {resumen.entregados + resumen.porEntregar > 0 &&
                        <Typography variant="h4">{resumen.entregados} - {Math.round(resumen.entregados / (resumen.entregados + resumen.porEntregar) * 100)}%</Typography>
                    }
                </Paper>
            </Grid>
            <Grid item xs={6}>
                <Paper style={{ padding: 16, textAlign: 'center', backgroundColor: '#ffebee', margin: 10 }}>
                    <Typography variant="h6">Kits por Entregar</Typography>
                    {resumen.entregados + resumen.porEntregar > 0 &&
                        <Typography variant="h4">{resumen.porEntregar} - {Math.round(resumen.porEntregar / (resumen.entregados + resumen.porEntregar) * 100)}%</Typography>
                    }
                </Paper>
            </Grid>
        </Grid>
    );
};

export default ResumenEntrega;
